import React, { useEffect, useState } from "react";
import { Badge, IconButton, Popover } from "@mui/material";
import { connect, useDispatch } from "react-redux";

import { HubIcon } from "../HubIcon";
import { getUnreadCount, setUnreadCount } from "../../redux/notifications";
import { useNotificationSSE } from "../../services/notifications/useNotificationSSE";
import { useGetUnreadCount } from "../../hooks/react-query/useNotificationsData";

import NotificationMenu from "./NotificationMenu";

const NotificationBell = ({ unreadCount = 0 }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  useNotificationSSE();

  // Fallback: poll unread count on mount in case SSE hasn't connected yet
  const { data: countData } = useGetUnreadCount();
  useEffect(() => {
    if (countData?.count != null) dispatch(setUnreadCount(countData.count));
  }, [countData]);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{ padding: "6px", color: "hubColors.grey" }}
      >
        <Badge
          variant="dot"
          color="error"
          invisible={unreadCount === 0}
          overlap="circular"
        >
          <HubIcon icon="Bell" size={16} />
        </Badge>
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "10px",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
              mt: "8px",
            },
          },
        }}
      >
        <NotificationMenu onClose={handleClose} />
      </Popover>
    </>
  );
};

const mapStateToProps = (state) => ({
  unreadCount: getUnreadCount(state),
});

export default connect(mapStateToProps)(NotificationBell);
